module.exports = __webpack_public_path__ + "static/media/cryptomania.72a10cbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/cryptomania.svg
// module id = 1085
// module chunks = 1